import { Col, Container, Row, Form } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import './Contact.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope';

const Contact = () => {

    return (
        <>
        <section className="contactSection d-flex justify-content-center align-items-center gap-5 flex-wrap">


            <div className="socialMediaContainer">
                <div className="mediaBox mt-1 d-flex align-items-center justify-content-between">
                    <FontAwesomeIcon icon={faGithub} className="fontIcon" />
                    <a href="https://github.com/VelaVelorem"><button type="submit" className="mediaButton">github</button></a>
                </div>

                <div className="mediaBox mt-5 d-flex align-items-center justify-content-between">
                    <FontAwesomeIcon icon={faLinkedin} className="me-5 fontIcon" />
                    <a href="https://www.linkedin.com/in/haneefah-witherspoon/"><button type="submit" className="mediaButton ms-3">linkedin</button></a>
                </div>

                <div className="mediaBox mt-5 d-flex align-items-center justify-content-between">
                    <FontAwesomeIcon icon={faEnvelope} className="fontIcon" />
                    <a href="https://formsubmit.co/el/cudina"><button type="submit" className="mediaButton">gmail</button></a>
                </div>

                <Link to="/fandango-project"><div className="d-flex justify-content-center mt-5"><button type="submit" className="mediaButton">Return</button></div></Link>

            </div>
            
            <footer>
            </footer>
        </section>

        
        </>
    )
}

export default Contact;